<script setup lang="ts">
defineProps<{ recommendation: 'CREATED' | 'PROCESSING' | 'REVIEW' | 'COMPLETE' | 'CANCELED' }>();

const styles: Record<'CREATED' | 'PROCESSING' | 'REVIEW' | 'COMPLETE' | 'CANCELED', string> = {
  CREATED: 'bg-blue-50 text-blue-700',
  PROCESSING: 'bg-indigo-50 text-indigo-700',
  REVIEW: 'bg-amber-50 text-amber-700',
  COMPLETE: 'bg-gray-100 text-gray-700',
  CANCELED: 'bg-red-50 text-red-700',
};

const labels: Record<'CREATED' | 'PROCESSING' | 'REVIEW' | 'COMPLETE' | 'CANCELED', string> = {
  CREATED: 'Created',
  PROCESSING: 'Processing',
  REVIEW: 'Needs Review',
  COMPLETE: 'Completed',
  CANCELED: 'Canceled',
};
</script>

<template>
  <span
    class="inline-flex w-fit items-center rounded-full px-2.5 py-0.5 text-xs font-semibold"
    :class="styles[recommendation]"
  >
    {{ labels[recommendation] }}
  </span>
</template>
